let httpAgent;
let httpsAgent;

const showLog = (name, agent) => {
  // eslint-disable-next-line no-console
  console.log(
    JSON.stringify({
      name,
      time: new Date(),
      freeSockets: Object.keys(agent.freeSockets).length,
      sockets: Object.keys(agent.sockets).length,
      requests: Object.keys(agent.requests).length,
    })
  );
};

const agentParams = {
  keepAlive: true,
  keepAliveMsecs: 40000,
  maxSockets: 100,
  maxFreeSockets: 10,
};

export const getHttpAgent = () => {
  if (!httpAgent) {
    const http = require("http");
    httpAgent = new http.Agent(agentParams);
  }

  return httpAgent;
};

export const getHttpsAgent = () => {
  if (!httpsAgent) {
    const https = require("https");
    httpsAgent = new https.Agent(agentParams);
  }

  return httpsAgent;
};

// 每10分钟打印一下agent状态
setInterval(() => {
  if (httpAgent) {
    showLog("httpAgent", httpAgent);
  }
  if (httpsAgent) {
    showLog("httpsAgent", httpsAgent);
  }
}, 720000);
